export const getCookieItem = (sKey: string) => {
	const value = decodeURIComponent(
		document.cookie.replace(
			new RegExp(
				"(?:(?:^|.*;)\\s*" +
				encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") +
				"\\s*\\=\\s*([^;]*).*$)|^.*$"
			),
			"$1"
		)
	);
	if (value) {
		try {
			return JSON.parse(value);
		} catch {
			return value;
		}
	}
	return null;
};
type TOptions = {
	days: number;
	months?: number;
	path?: string;
	domain?: string;
}
export function setCookieItem(
	name: string,
	value: string,
	options?: TOptions
): void {
	const date = new Date();
	let defaultOptions: TOptions = {
		days: 30,
		path: "/",
	};
	if (options) {
		defaultOptions = {
			...defaultOptions,
			...options,
		};
	}
	const { days, months, path = "/" } = defaultOptions;
	if (months && months > 0) {
		const m = date.getMonth() + months;
		if (m > 11) {
			date.setFullYear(date.getFullYear() + 1);
			date.setMonth(m - 11 - 1);
		} else {
			date.setMonth(m);
		}
	} else {
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
	}
	const expires = "expires=" + date.toUTCString();
	value = encodeURIComponent(value);
	let cookieStr = `${name}=${value}; ${expires}; path=${path};`
	const isLocal = window.location.hostname === "localhost";
	if (!isLocal) {
		cookieStr += " SameSite=None; secure";
	}
	document.cookie = cookieStr;
}

export function removeCookieItem(name: string): void {
	setCookieItem(name, "", { days: -1 });
}
export function getAllCookieKeys(): string[] {
	return document.cookie.split("; ").map((item) => item.split("=")[0]);
}

